import { useState, useEffect, useCallback } from "react";
import { useAuth } from "./useAuth";
import { getCurrencySymbol } from "../utils";

export const useCurrency = () => {
  const [currency, setCurrency] = useState("USD");
  const [isLoading, setIsLoading] = useState(true);
  const { apiClient, teamId } = useAuth();

  const loadCurrency = useCallback(async () => {
    try {
      // Check localStorage first for immediate response
      const cachedCurrency = localStorage.getItem("defaultCurrency");
      if (cachedCurrency) {
        setCurrency(cachedCurrency);
        setIsLoading(false);
        return;
      }

      // Fetch from backend to ensure we have the latest data
      if (teamId) {
        const response = await apiClient.get(`/team-settings/${teamId}/`);
        const backendCurrency = response.data.currency || "USD";

        setCurrency(backendCurrency);
        localStorage.setItem("defaultCurrency", backendCurrency);
      }
    } catch (error) {
      console.error("Error loading currency:", error);
      // Fallback to cached or default currency
      const fallbackCurrency = localStorage.getItem("defaultCurrency") || "USD";
      setCurrency(fallbackCurrency);
    } finally {
      setIsLoading(false);
    }
  }, [teamId, apiClient]);

  useEffect(() => {
    loadCurrency();

    // Listen for currency changes from other components (like TeamSettings)
    const handleCurrencyChange = (event) => {
      setCurrency(event.detail.currency);
    };

    window.addEventListener("currencyChanged", handleCurrencyChange);

    return () => {
      window.removeEventListener("currencyChanged", handleCurrencyChange);
    };
  }, [loadCurrency]);

  return {
    currency,
    currencySymbol: getCurrencySymbol(currency),
    isLoading,
    refreshCurrency: loadCurrency,
  };
};
